export var HttpStatusCodes = {
    status100Continue: 100,
    status101SwitchingProtocols: 101,
    status102Processing: 102,
    status200OK: 200,
    status201Created: 201,
    status202Accepted: 202,
    status203NonAuthoritative: 203,
    status204NoContent: 204,
    status205ResetContent: 205,
    status206PartialContent: 206,
    status207MultiStatus: 207,
    status208AlreadyReported: 208,
    status226IMUsed: 226,
    status300MultipleChoices: 300,
    status301MovedPermanently: 301,
    status302Found: 302,
    status303SeeOther: 303,
    status304NotModified: 304,
    status305UseProxy: 305,
    status306SwitchProxy: 306,
    status307TemporaryRedirect: 307,
    status308PermanentRedirect: 308,
    status400BadRequest: 400,
    status401Unauthorized: 401,
    status402PaymentRequired: 402,
    status403Forbidden: 403,
    status404NotFound: 404,
    status405MethodNotAllowed: 405,
    status406NotAcceptable: 406,
    status407ProxyAuthenticationRequired: 407,
    status408RequestTimeout: 408,
    status409Conflict: 409,
    status410Gone: 410,
    status411LengthRequired: 411,
    status412PreconditionFailed: 412,
    status413RequestEntityTooLarge: 413,
    status413PayloadTooLarge: 413,
    status414RequestUriTooLong: 414,
    status414UriTooLong: 414,
    status415UnsupportedMediaType: 415,
    status416RequestedRangeNotSatisfiable: 416,
    status416RangeNotSatisfiable: 416,
    status417ExpectationFailed: 417,
    status418ImATeapot: 418,
    status419AuthenticationTimeout: 419,
    status421MisdirectedRequest: 421,
    status422UnprocessableEntity: 422,
    status423Locked: 423,
    status424FailedDependency: 424,
    status426UpgradeRequired: 426,
    status428PreconditionRequired: 428,
    status429TooManyRequests: 429,
    status431RequestHeaderFieldsTooLarge: 431,
    status451UnavailableForLegalReasons: 451,
    status500InternalServerError: 500,
    status501NotImplemented: 501,
    status502BadGateway: 502,
    status503ServiceUnavailable: 503,
    status504GatewayTimeout: 504,
    status505HttpVersionNotsupported: 505,
    status506VariantAlsoNegotiates: 506,
    status507InsufficientStorage: 507,
    status508LoopDetected: 508,
    status510NotExtended: 510,
    status511NetworkAuthenticationRequired: 511,
};

//# sourceMappingURL=httpStatusCodes.js.map
